/**
 * @file Enumerator of currently supported filter operators.
 * @author Tom Verschoore de la Houssaije
 */
/**
 * The current Symagic Server does not support the following operators:
 * StartsWith, Any, All, Contains, EndsWith and IsTypeOf.
 */
export var FilterOperators;
(function (FilterOperators) {
    /** Concatenate '&&' operator */
    FilterOperators[FilterOperators["And"] = 0] = "And";
    /** Concatenate '||' operator */
    FilterOperators[FilterOperators["Or"] = 1] = "Or";
    /** Comparison '===' operator */
    FilterOperators[FilterOperators["Equals"] = 2] = "Equals";
    /** Comparison '>' operator */
    FilterOperators[FilterOperators["GreaterThan"] = 3] = "GreaterThan";
    /** Comparison '>=' operator */
    FilterOperators[FilterOperators["GreaterThanOrEqual"] = 4] = "GreaterThanOrEqual";
    /** Comparison '<' operator */
    FilterOperators[FilterOperators["LessThan"] = 5] = "LessThan";
    /** Comparison '<=' operator */
    FilterOperators[FilterOperators["LessThanOrEqual"] = 6] = "LessThanOrEqual";
    /** Comparison '!==' operator */
    FilterOperators[FilterOperators["NotEquals"] = 7] = "NotEquals";
    /** Negate '!' operator */
    FilterOperators[FilterOperators["Not"] = 8] = "Not";
    /** Contains operatpr */
    FilterOperators[FilterOperators["Contains"] = 9] = "Contains";
})(FilterOperators || (FilterOperators = {}));
